/* Copyright (c) 2022 Xperi. All Rights Reserved.  */

import React, { FunctionComponent } from 'react';
import PropTypes from 'prop-types';
import { SeparatorProps } from './SeparatorProps';

import './Seperator.scss';

const Seperator: FunctionComponent<SeparatorProps> = ({ type }: SeparatorProps): JSX.Element => {
    return <div className={`seperator ${type || ''}`} />;
};

Seperator.propTypes = {
    type: PropTypes.string,
};

export default Seperator;
